import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import { defineRole } from "../handleAccessRoles";
import { ROLE_TEST_ASSAY_RULE } from "../../constants/ROLES";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchTestAssayRules = async (
  lng = "english",
  { page, limit, id, disease, assayRole, stage, testType, q, isActive, ruleType, bloodGroupScenario } = {}
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_TEST_ASSAY_RULE,
      operation: "read,readOnAction",
    });

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/testAssayRule`,
      params: {
        page,
        limit,
        id,
        disease,
        assayRole,
        stage,
        testType,
        q,
        isActive,
        ruleType,
        bloodGroupScenario,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords, totalPages } = queryRes.data;

    return !page && !limit
      ? queryRes.data
      : { data, count, totalRecords, totalPages };
  } catch (error) {
    console.log(error);
    toastMessage("error", error);
  }
};

export const createTestAssayRule = async (lng = "english", body) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_TEST_ASSAY_RULE,
      operation: "create",
    });

    if (!canAccess) return;

    const options = {
      method: "POST",
      url: `${API_URL}/testAssayRule`,
      data: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    const res = await api(options);
    toastMessage("success", language[lng].success_create_test_assay_rule);
    return res.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const updateTestAssayRule = async (lng = "english", body) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_TEST_ASSAY_RULE,
      operation: "update",
    });

    if (!canAccess) return;

    const options = {
      method: "PUT",
      url: `${API_URL}/testAssayRule`,
      data: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    const res = await api(options);
    toastMessage("success", language[lng].success_update_test_assay_rule);
    return res.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteTestAssayRule = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_TEST_ASSAY_RULE,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/testAssayRule`,
      data: { id },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);
    toastMessage("success", language[lng].success_delete_test_assay_rule);
  } catch (error) {
    toastMessage("error", error);
  }
};
